import googleSheetImage from 'assets/img/google_logo.svg';
import airtableImage from 'assets/img/airtable.png';

export const GOOGLE_SHEETS = 'google_sheets';
export const AIRTABLE = 'airtable';

const OLD_URL_INTEGRATIONS = ['https://twnel-be-apis.api.production.twnel.io'];

export const BASE_URL_INTEGRATION = 'https://apis.twnel.io';

export const OTHER_BASE_URL_INTEGRATIONS = OLD_URL_INTEGRATIONS;

export const API_INTEGRATIONS = [
  {
    text: 'Own Service',
    value: '',
    services: {},
  },
  {
    text: 'Google',
    value: GOOGLE_SHEETS,
    services: {
      create: 'Save new row',
      read: 'Get data',
      update: 'Update row',
      delete: 'Delete row',
      ocr: 'Extract data',
      invoiceOcr: 'Invoice OCR',
      dynamicPDF: 'Dynamic PDF',
      sendEmail: 'Send email',
    },
  },
  {
    text: 'Airtable',
    value: AIRTABLE,
    services: {
      create: 'Save new row',
      read: 'Get data',
      update: 'Update row',
      delete: 'Delete row',
    },
  },
];

export const INTEGRATIONS = {
  GOOGLE_SHEETS,
  AIRTABLE,
};

export const VALUE_TIME_CAP = 5000;
export const VALUE_TIME_OUT = 5000;

export const INTEGRATIONS_VIEW = {
  [GOOGLE_SHEETS]: {
    title: 'Google',
    message: "Utilize Google Workspace, including Google Sheets, Gmail for email delivery, dynamic PDF generation, and OCR reading, as a comprehensive data storage and management solution for your bot. To enable this integration, grant us access to your Google account by clicking the 'Authorize' button below",
    headers: [
      {
        label: 'Permission',
        width: '50%',
      },
      {
        label: 'Status',
        width: '50%',
      },

    ],
    image: googleSheetImage,
  },
  [AIRTABLE]: {
    title: 'Airtable',
    message: 'Use Airtable as a storage solution for your bot. To use this integration you must authorize us to access your tables by providing your Airtable Api Key',
    headers: [
      {
        label: 'Key',
        width: '50%',
      },
      {
        label: 'Value',
        width: '50%',
      },
    ],
    image: airtableImage,
  },
};
